export const authModule = {
  namespaced: true,
  state: () => ({
    step: null,
    from: '',
  }),
  mutations: {
    setStep(state, step) {
      state.step = step
    },
    setFrom(state, from) {
      state.from = from
    },
    close(state) {
      state.step = null
    },
  },
}
